import { ROUTES } from 'constants/routes';
import variant1 from 'images/icons/headerIcons/variant1.svg';
import variant2 from 'images/icons/headerIcons/variant2.svg';
import variant3 from 'images/icons/headerIcons/variant3.svg';
import variant4 from 'images/icons/headerIcons/variant4.svg';
import variant5 from 'images/icons/headerIcons/variant5.svg';
import variant6 from 'images/icons/headerIcons/variant6.svg';
import variant7 from 'images/icons/headerIcons/variant7.svg';
import variant8 from 'images/icons/headerIcons/variant8.svg';

import logo1 from 'images/products-logo/product-logo-with-blur-1.svg';
import logo2 from 'images/products-logo/product-logo-with-blur-2.svg';
import logo3 from 'images/products-logo/product-logo-with-blur-3.svg';
import logo4 from 'images/products-logo/product-logo-with-blur-4.svg';

export const data = [
    {
        name: 'Company',
        items: [
            { name: 'About us', link: ROUTES.aboutUs, icons: [variant1] },
            { name: 'Research, news & events', link: ROUTES.news, icons: [variant8, variant2, variant7] },
            { name: 'Career', link: ROUTES.career, icons: [variant3] },
        ],
    },
    {
        name: 'Products',
        button: {
            name: 'all products',
            link: ROUTES.products,
        },
        items: [
            {
                icons: [logo1],
                name: 'Organic line',
                link: ROUTES.aboutProduct,
            },
            {
                icons: [logo2],
                name: 'Wuxal',
                link: ROUTES.aboutProduct,
            },
            {
                icons: [logo3],
                name: 'Fertiplant',
                link: ROUTES.aboutProduct,
            },
            {
                icons: [logo4],
                name: 'UniferX',
                link: ROUTES.aboutProduct,
            },
        ],
    },
    {
        name: 'Resources',
        button: {
            name: 'all resources',
            link: ROUTES.resources,
        },
        items: [
            {
                icons: [variant4],
                name: 'Crop nutrition programs',
                link: ROUTES.cropNutritionPrograms,
            },
            {
                icons: [variant5],
                name: 'Trial results',
                link: ROUTES.trialResults,
            },
            {
                icons: [variant6],
                name: 'Information materials',
                link: ROUTES.informationMaterials,
            },
        ],
    },
    { name: 'Contacts', link: ROUTES.contacts },
];
